import axios from 'axios'
import { API_URL, API_V2_URL } from '../../fixtures/apiUrls'

const handleResponse = (res) => {
  if (!res) return { ok: false }

  const { data, status } = res
  const ok = status && status >= 200 && status < 300

  return { ok, status, data }
}

const attachResponseInterceptor = (instance) => {
  instance.interceptors.response.use(
    (response) => handleResponse(response),
    (error) => {
      const { response, config, message } = error
      console.log(response, config, message, error, 'httpInstance:AxiosResponseErrorInterceptor')
      return handleResponse(response)
    }
  )
  return instance
}

const http = attachResponseInterceptor(axios.create({ timeout: 30000, baseURL: API_URL }))

// v2 API client (Core - Staff). Used by modules that talk to the new v2 API (e.g. Leads).
export const httpV2 = attachResponseInterceptor(axios.create({ timeout: 30000, baseURL: API_V2_URL }))

export default http